import React from "react";
import ProfilePageTemplate from "../shared/ProfilePageTemplate";
import OrganizationStructure from "../shared/OrganizationStructure";

const RenminContent: React.FC = () => {
  const OverviewContent = () => (
    <div className="p-8">
      <div className="prose prose-lg max-w-none">
        <h2 className="text-2xl font-bold mb-4">
          Bagian Perencanaan dan Administrasi (RENMIN)
        </h2>
        <p className="text-base-content/70 leading-relaxed mb-6">
          Bagrenmin bertugas menyusun perencanaan kerja dan anggaran,
          pengelolaan dan pembinaan manajemen sumber daya manusia dan logistik
          serta pembinaan fungsi di lingkungan Divhubinter Polri.
        </p>

        <h3 className="text-xl font-bold mb-4">Fungsi</h3>
        <p className="text-base-content/70 mb-4">
          Dalam melaksanakan tugas, Bagrenmin menyelenggarakan fungsi:
        </p>
        <ol className="list-decimal list-inside space-y-3 text-base-content/70">
          <li className="leading-relaxed">
            penyusunan dokumen perencanaan dan anggaran antara lain Renstra,
            Renja, RKA-KL, DIPA, Perjanjian Kinerja, LKIP, LRA, SMAP, IKU dan
            IKK, Hibah, evaluasi kinerja serta mengarahkan dan mengawasi
            pelaksanaan kegiatan dan anggaran;
          </li>
          <li className="leading-relaxed">
            pelaksanaan pemeliharaan, perawatan, serta pengelolaan administrasi
            personel;
          </li>
          <li className="leading-relaxed">
            pengelolaan logistik dan penyusunan laporan SIMAK-BMN;
          </li>
          <li className="leading-relaxed">
            pembinaan fungsi yang meliputi pembinaan organisasi, perumusan dan
            pengembangan sistem dan metode, Sistem Pengendalian Intern
            Pemerintah (SPIP), Pengelolaan Informasi dan Dokumentasi (PID) serta
            pelaksanaan RBP; dan
          </li>
          <li className="leading-relaxed">pembinaan jabatan fungsional.</li>
        </ol>
      </div>
    </div>
  );

  const organizationUnits = [
    {
      name: "Subbagian Perencanaan",
      abbreviation: "Subbagren",
      description:
        "Menyusun dokumen perencanaan dan anggaran serta evaluasi kinerja Divhubinter Polri",
    },
    {
      name: "Subbagian Sumber Daya",
      abbreviation: "Subbagsumda",
      description:
        "Mengelola administrasi personel dan logistik di lingkungan Divhubinter Polri",
    },
    {
      name: "Subbagian Bina Fungsi",
      abbreviation: "Subbagbinfungi",
      description:
        "Melaksanakan pembinaan organisasi, sistem dan metode, serta fungsi-fungsi pendukung lainnya",
    },
    {
      name: "Urusan Administrasi",
      abbreviation: "Urmin",
      description: "Mengelola administrasi bagian perencanaan dan administrasi",
    },
  ];

  const tabs = [
    {
      id: "overview",
      label: "Gambaran Umum",
      icon: "📋",
      component: <OverviewContent />,
    },
    {
      id: "structure",
      label: "Struktur Organisasi",
      icon: "🏗️",
      component: (
        <OrganizationStructure
          mainTitle="Struktur Organisasi Bagian Renmin"
          mainDescription="Dalam melaksanakan tugas, Bagrenmin dibantu oleh 4 (empat) unit kerja:"
          units={organizationUnits}
        />
      ),
    },
  ];

  return (
    <ProfilePageTemplate
      title="Profil Renmin"
      subtitle="Bagian Perencanaan dan Administrasi"
      icon="📊"
      breadcrumbBase="Tentang"
      tabs={tabs}
      footerTitle="Bagian Renmin"
      footerDescription="Menyusun perencanaan kerja dan anggaran serta mengelola sumber daya untuk mendukung operasional Divhubinter Polri."
      footerStats={[
        { label: "Unit Kerja", value: "4" },
        { label: "Fungsi Utama", value: "5" },
        { label: "Dokumen", value: "10+ Jenis" },
      ]}
    />
  );
};

export default RenminContent;
